import { render, staticRenderFns } from "./manageWellActivities.vue?vue&type=template&id=f2777386"
import script from "./manageWellActivities.vue?vue&type=script&lang=ts"
export * from "./manageWellActivities.vue?vue&type=script&lang=ts"
import style0 from "./manageWellActivities.vue?vue&type=style&index=0&id=f2777386&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports